import r from '~/utils/render-utils';

const PageLoanIndex = () => import(/* webpackChunkName: 'loan-index-page' */ '~/pages/Loan/Index.vue');
const PageLoanSimulation = () => import(/* webpackChunkName: 'loan-simulation-page' */ '~/pages/Loan/Simulation.vue');
const PageLoanDisbursementDetail = () => import(/* webpackChunkName: 'loan-disbursement-detail-page' */ '~/pages/Loan/DisbursementDetail.vue');

export default [
  { path: '/loan', component: r(PageLoanIndex), name: 'cash_loan' },
  { path: '/loan/simulation', component: r(PageLoanSimulation), name: 'cash_loan_simulation' },
  { path: '/loan/disbursement/:id', component: r(PageLoanDisbursementDetail), name: 'cash_loan_riwayat' },
];
